'use client'

interface TagFilterProps {
  tags: string[]
  selectedTags: string[]
  onTagsChange: (tags: string[]) => void
  postCount: number
}

export function TagFilter({
  tags,
  selectedTags,
  onTagsChange,
  postCount,
}: TagFilterProps) {
  function handleToggle(tag: string) {
    const next = selectedTags.includes(tag)
      ? selectedTags.filter((t) => t !== tag)
      : [...selectedTags, tag]
    onTagsChange(next)
  }

  return (
    <div className="sticky top-20 rounded-[var(--card-radius)] border border-[var(--card-border)] bg-[var(--card-bg)] p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-[var(--color-text-primary)]">
          Filter by tag
        </h3>
        {selectedTags.length > 0 && (
          <button
            type="button"
            onClick={() => onTagsChange([])}
            className="text-xs text-[var(--color-brand-indigo)] hover:opacity-80 transition-opacity"
          >
            Clear all
          </button>
        )}
      </div>

      <div className="space-y-2">
        {tags.map((tag) => (
          <label
            key={tag}
            className="flex cursor-pointer items-center gap-2 text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] transition-colors"
          >
            <input
              type="checkbox"
              checked={selectedTags.includes(tag)}
              onChange={() => handleToggle(tag)}
              className="rounded border-[var(--color-border-default)] accent-[var(--color-brand-indigo)]"
              aria-label={`Filter by ${tag}`}
            />
            {tag}
          </label>
        ))}
      </div>

      <div className="mt-4 border-t border-[var(--color-border-default)] pt-3 text-xs text-[var(--color-text-muted)]">
        {postCount} {postCount === 1 ? 'article' : 'articles'} found
      </div>
    </div>
  )
}
